import { MODAL_TYPE_POST_EDITOR, isOneAppSearchParam } from '@wix/communities-blog-client-common';
import { getPost } from '../selectors/post-selectors';
import { isEditor } from '../selectors/view-mode-selectors';
import { push } from '../services/router-utils';
import { updatePost } from './update-post';
import { closeModal } from './close-modal';

const handleDiscardSuccess = (post) => (dispatch, getState) => {
  const state = getState();
  const url = isEditor(state) ? '/' : `/${post.slug}`;
  dispatch(push(url));
};

const handleDiscardSuccessInOneApp = (post) => closeModal({ type: MODAL_TYPE_POST_EDITOR, resolve: post });

export const discardPostDraft = (postId) => (dispatch, getState) => {
  const successHandler = isOneAppSearchParam(getState()) ? handleDiscardSuccessInOneApp : handleDiscardSuccess;

  dispatch(updatePost(getPost(getState(), postId))).then((post) => dispatch(successHandler(post)));
};
